<div id="grayBg">
  <div class="container mt-3 pb-5 twoCard">
    <div class="row d-flex justify-content-center">
      <div class="col-sm-6 col-md-6 col-xl-4 mt-5 pb-5">
        <div class="card stretch gradient-bg border-0 h-100">
          <div class="card-body">
            <img
              src="../../../assets/images/gradientCard/bldg.png"
              alt="Icon Image of City Building"
              class="cityBuilding mt-5 pb-5"
            />
          </div>
        </div>
        <div class="textBox">
          <h2>Sed ut perspiciatis</h2>
        </div>
      </div>
      <div class="col-sm-6 col-md-6 col-xl-4 mt-5 pb-5">
        <div class="card stretch gradient-bg border-0 h-100">
          <div class="card-body">
            <img
              src="../../../assets/images/gradientCard/calendar.png"
              alt="Icon Image of City Building"
              class="cityBuilding mt-5 pb-5"
            />
          </div>
        </div>
        <div class="textBox">
          <h2>Sed ut perspiciatis</h2>
        </div>
      </div>
    </div>
  </div>
</div>
